import React, { Component } from 'react';
import { connect } from 'react-redux';
import { CSSTransition } from 'react-transition-group';
import { cambiarStringApp, checkStatusEnApi } from '../actions';
import Menu from './common/Menu';
import Header from './common/Header';
import DescubreAntarie from './common/DescubreAntarie';
import Footer from './common/Footer';
import Cargador from './common/Cargador';
import './App.css';

class App extends Component {
  constructor(props) {
    super(props);

    this.props.checkStatusEnApi();
  }

  handleClickWebCentral = () => {
    if (this.props.menuVisible === true) { this.props.cambiarStringApp('menuVisible', false); }
  }

  renderHeader() {
    if (this.props.render_header === false) { return null; }

    return <Header />;
  }

  renderDescubre() {
    if (this.props.render_descubre === false) { return null; }

    return <DescubreAntarie />;
  }

  renderFooter() {
    if (this.props.render_footer === false) { return null; }

    return <Footer />;
  }

  renderView() {
    if (this.props.status_app === 'checking') {
      return <Cargador />;
    }

    return (
      <>
        <Menu in={this.props.menuVisible} />
        <CSSTransition classNames="moverWeb" in={this.props.menuVisible} timeout={{ appear: 0, enter: 500, exit: 500 }}>
          <div className="webCentral" onClick={this.handleClickWebCentral}>
            {this.renderHeader()}
            {this.props.children}
            {this.renderDescubre()}
            {this.renderFooter()}
          </div>
        </CSSTransition>
      </>
    );
  }

  render() {
    return (
      <div>
        {this.renderView()}
      </div>
    );
  }
}

const mapStateToProps = ({ app }) => {
  const { render_header, render_descubre, render_footer, status_app, menuVisible } = app;

  return { render_header, render_descubre, render_footer, status_app, menuVisible };
};

export default connect(mapStateToProps, { cambiarStringApp, checkStatusEnApi })(App);
